import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import { UserDashboard, AdminDashboard, SuperAdminDashboard } from './dashboard'

export const DashboardPage: React.FC = () => {
  const { user } = useAuth()

  switch (user?.role) {
    case 'SUPER_ADMIN':
      return <SuperAdminDashboard />
    case 'CORPORATE_ADMIN':
      return <AdminDashboard />
    default:
      return <UserDashboard />
  }
}
